import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/___LOGIC/___common/__config/config.service';
import { DataProviderService } from 'src/app/___LOGIC/__data/data-provider.service';
import { ShopifyService } from 'src/app/___LOGIC/__shopify/shopify.service';

@Component({
  selector: 'app-webapp-menu',
  templateUrl: './webapp-menu.component.html',
  styleUrls: ['./webapp-menu.component.css']
})
export class WebappMenuComponent implements OnInit {

  usefulResources = {
    title: 'Recursos Útiles',
    array: [
      /* { title: 'Videollamada gratis', description: 'Videollamada inicial para cononcer tus planes', icon: 'video_call', link: '' }, */
      { title: 'Videollamada inicial', description: 'Videollamada inicial para cononcer tus planes y solventar tus dudas.', icon: 'video_call', link: '' },
      /* { title: 'Guía para elegir seguro médico', description: 'Todo lo que necesitas saber para elegir tu seguro médico.', icon: 'security' },
      { title: 'Guía para elegir seguro médico', description: 'Todo lo que necesitas saber para elegir tu seguro médico.', icon: 'security' }, */
      /* { title: 'Requisitos Visa estudiante', description: 'Los requisitos que debes conocer de la visa para estudiar en España', icon: 'airplanemode_active', link: 'https://calendly.com/voy-jaleas/30min?month=2023-02' } */
    ]
  };

  constructor(private router: Router,private dataProvider: DataProviderService,private shopifyService: ShopifyService,private configService: ConfigService) {}

  ngOnInit(): void {
  }

  preloadDemoWebapps(){}

  getVisibleSections(){
    return this.dataProvider.getVisibleApps();
  }

  navigateToApp(app) {
    this.router.navigate([`/sub-app/${app.component}`]);
  }

  getImageUrl(appObj){
    return this.dataProvider.getImageUrl(appObj.app);
  }

  getClass(app){
    let css;
    app.disabled? css = 'access-link-wrapper disabled' : css = 'access-link-wrapper';
    return css;
  }

  isActive(obj){
    return obj.active == 1 || obj.active == '1';
  }

  openSnackBar() {
/*     this._snackBar.openFromComponent(NotificationComponent, {
      data: { 
        text: 'Esta aplicación estará disponible proximamente'
       },
      duration: 2000,
      horizontalPosition: 'start',
      verticalPosition: 'top'
    }); */
  }

  menuButtonClicked(menuButton){
    if(this.isActive(menuButton)){
      this.showSection(menuButton);
    }else{
      this.openSnackBar();
    }
  }

  showSection(section){
    this.router.navigateByUrl(section.url);
  }

  areAppsLoading(){
   /*  return this.resolver.isLoading('clientApps'); */
  }

  handleCta(status){

  }

  buyProductSimple(myVariantLabel){
    let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
    };
    this.shopifyService.buyProduct(orderObject);
  }
}
